import {ApiFunction, ChatbotApi} from "../chatbot/towersChatbotApi";

export class UserLocalStorageApi {
    static async getItem({key}): Promise<{ item: any }> {
        const fn = new ApiFunction('storage-getItem', ChatbotApi.baseUrl);
        return fn.call({key});
    }

    static async setItem({key, value}) {
        const fn = new ApiFunction('storage-setItem', ChatbotApi.baseUrl);
        return fn.call({key, value});
    }

    static async removeItem({key}) {
        const fn = new ApiFunction('storage-removeItem', ChatbotApi.baseUrl);
        return fn.call({key});
    }
}
